module.exports = __webpack_public_path__ + "static/media/jade.a231634d.png";